<template>
  <div class="Woodie">
    <ol>
      <li>괴물고기를 2개씩 먹어가며 랜덤 동물로 변신합니다</li>
      <li>명데와 같은 동물로 변신한 사람들은 살아남습니다</li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'Woodie'
}
</script>


// WEBPACK FOOTER //
// src/components/Mission/Woodie.vue